import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    bus: [],
    bu: null,
    applicationDetail: null,
    technologyDetail: null,
    quiktipsDetail: null,
    links: null,
    meta: null,
    filter: {
      keyword: null,
      status: null,
    },
  },

  mutations: {
    INIT_BU(state) {
      state.bu = {
        sections: [],
        bu_messaging: {
          title: '',
          description: '',
          image: '',
        },
        news_bannervideo: [],
        application: {
          title: '',
          banner: '',
          details: [],
        },
        teamsponsorship: [],
        video_rotate: [],
        technology_highlight: {
          title: '',
          banner: '',
          details: [],
        },
        quiktips: {
          title: '',
          banner: '',
          details: [],
        },
        news_and_events: [],
      };
    },
    CLEAR_BUINFO(state) {
      state.bu = null;
      state.applicationDetail = null;
      state.technologyDetail = null;
      state.quiktipsDetail = null;
    },
    SET_BU(state, data) {
      state.bu = data;
    },
    SET_BUS(state, data) {
      state.bus = data.data.map((item) => {
        item.isChecked = false;
        return item;
      });
      state.links = data.links;
      state.meta = data.meta;
    },
    INIT_APPLCATION_DETAIL(state, detail) {
      state.applicationDetail = detail;
    },
    INIT_TECHNOLOGY_DETAIL(state, detail) {
      state.technologyDetail = detail;
    },
    INIT_QUICKTIPS_DETAIL(state, detail) {
      state.quiktipsDetail = detail;
    },
    SET_APPLCATION_DETAIL(state, detail) {
      if (!state.bu.application.details) {
        state.bu.application.details = [];
      }

      if (detail.id) {
        const index = state.bu.application.details
          .map((i) => i.id)
          .indexOf(detail.id);
        state.bu.application.details[index] = detail;
      } else {
        state.bu.application.details.push(detail);
      }
    },
    SET_TECHNOLOGY_DETAIL(state, detail) {
      if (!state.bu.technology_highlight.details) {
        state.bu.technology_highlight.details = [];
      }

      if (detail.id) {
        const index = state.bu.technology_highlight.details
          .map((i) => i.id)
          .indexOf(detail.id);
        state.bu.technology_highlight.details[index] = detail;
      } else {
        state.bu.technology_highlight.details.push(detail);
      }
    },
    SET_QUICKTIPS_DETAIL(state, detail) {
      if (!state.bu.quiktips.details) {
        state.bu.quiktips.details = [];
      }

      if (detail.id) {
        const index = state.bu.quiktips.details
          .map((i) => i.id)
          .indexOf(detail.id);
        state.bu.quiktips.details[index] = detail;
      } else {
        state.bu.quiktips.details.push(detail);
      }
    },
  },

  actions: {
    init({ commit }) {
      commit('INIT_BU');
    },

    clear({ commit }) {
      commit('CLEAR_BUINFO');
    },

    initApplicationDetail({ commit }, detail) {
      commit('INIT_APPLCATION_DETAIL', detail);
    },

    initTechnologyDetail({ commit }, detail) {
      commit('INIT_TECHNOLOGY_DETAIL', detail);
    },

    initQuicktipsDetail({ commit }, detail) {
      commit('INIT_QUICKTIPS_DETAIL', detail);
    },

    setApplicationDetail({ commit }, detail) {
      commit('SET_APPLCATION_DETAIL', detail);
    },

    setTechnologyDetail({ commit }, detail) {
      commit('SET_TECHNOLOGY_DETAIL', detail);
    },

    setQuicktipsDetail({ commit }, detail) {
      commit('SET_QUICKTIPS_DETAIL', detail);
    },

    find({ commit, state }) {
      let url = `/bus?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Bu'));
          return response.body;
        })
        .then((response) => {
          commit('SET_BUS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/bus/${id}`)
        .then((response) => response.body)
        .then(typeAs('Bu'))
        .then((item) => {
          commit('SET_BU', item);
        });
    },

    save(_, { id, ...data }) {
      const request = id
        ? http(`/bus/${id}`, { method: 'PUT', data })
        : http('/bus', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    destroy(_, id) {
      return http(`/bus/${id}`, { method: 'DELETE' }).then(
        (response) => response.body,
      );
    },

    publish(_, data) {
      const request = http('/bu/publish', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    supportPublish(_, data) {
      const request = http('/bu/support_publish', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    sections() {
      return http('/bu_sections').then((response) => response.body);
    },

    all() {
      return http('/bus/all').then((response) => response.body);
    },
    // 取得所屬新聞
    getCases(_, id) {
      const request = id ? http(`/newsbyID/${id}`) : http('/news/all');
      return request.then((response) => response.body);
    },

    // 檢查Quiktips Slug設定狀況
    checkQuiktipsSlug(_, id) {
      const request = id ? http(`/quiktipSlug/${id}`) : http('/quiktipSlug/');
      return request.then((response) => response.body);
    },
  },
};
